
import { Component, Prop, Vue } from 'vue-property-decorator'
import TitlePanel from '@/components/organisms/TitlePanel.vue'
import ReviewBoxContent from '@/components/organisms/ReviewBoxContent.vue'
import SidemenuLayout from '@/components/organisms/layout/SidemenuLayout.vue'
import { ReviewBoxCurriculumUnit } from '@/models/CurriculumUnit'

/**
 * 復習ボックス
 */
@Component({
  components: {
    TitlePanel,
    ReviewBoxContent,
    SidemenuLayout,
  },
})
export default class ReviewCurriculumUnitList extends Vue {
  /** 単元情報一覧 */
  @Prop()
  private curriculumUnitList!: ReviewBoxCurriculumUnit[]

  /** 単元クリック時のイベント */
  @Prop()
  private eventClickCurriculumUnit!: (curriculumUnitId: number) => void

  /**
   * 表示する単元が有るか否か
   *
   * @returns 単元が有ればtrue
   */
  private get isCurriculumUnit(): boolean {
    return this.curriculumUnitList.length > 0
  }
}
